// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__EhrMg","navSearch":"Navbar_navSearch__9b4UJ"};